<template>
    <BaseDialog 
            :showDialog="showUploadDialog"
            headline="lang_GENERAL_CAPTION_UPLOAD_FILE"
            :close="closeUploadDialog"
            maxDialogWidth="600"
            maxCardHeight="500"
            :alvqa="alvqa"
        >
            <template v-slot:dialogText>
                <v-row>
                    <v-col :alvqa="alvqa + '-text'" v-html="dialogText"></v-col>
                </v-row>
            </template>
            <template v-slot:actionsWithValidation>
                <v-card-actions  v-if="showUploadActions" class="pt-0 pb-0 pr-6 pl-6">
                    <v-container fluid>
                        <v-form v-model="valid">
                            <v-row>
                                <v-col cols="7" class="pl-0">                                
                                    <v-file-input
                                        v-model="file"
                                        :label="$t('lang_GENERAL_BUTTON_UPLOAD_FILE')"
                                        @change="fileExt = $alvPlugin.extractFileExt(file)"
                                        @click:clear="resetVal()"
                                        :rules="rules"
                                        show-size
                                        :alvqa="alvqa + '-file-input'"
                                    ></v-file-input>                                
                                </v-col>
                                <v-spacer />
                                <v-col 
                                    class="text-right" 
                                    align-self="center"
                                >
                                    <BaseButton 
                                        :disabled="!valid || !file"
                                        label="lang_GENERAL_BUTTON_UPLOAD_FILE"
                                        @click="submitFile"
                                        :alvqa="alvqa+'-button-upload'"
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-actions>
            </template>
        </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "A6BackgroundImageUploadDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    props: {
        item: Object
    },
    data() {
        return {
            showCloseButton: false,
            showUploadActions: true,
            file: null,
            dialogText: '',
            valid: false,
            rules: [
                value => !value || 
                this.isA6BackgroundFileExtAccepted() || 
                this.$t('lang_GENERAL_DIALOG_TEXT_INVALID_FORMAT') 
            ],
            formData: new FormData(),
            fileExt: '',
            alvqa: 'account-settings-dialog-a6-background-image'
        }
    },
    computed: {
        showUploadDialog: {
            get() { return this.$store.getters.getShowUploadDialog },
            set(show) { this.$store.commit('setShowUploadDialog', show) }
        },
    },
    methods: {
        closeUploadDialog() {
            this.showUploadDialog = false
            this.showCloseButton = false
            this.showUploadActions = true
            this.dialogText = this.$t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') 
                                + ' ' + this.$t('lang_ACCOUNT_SETTINGS_DIALOG_BACKGROUND_FILE_A6') + '. <br />' +
                                this.$t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE').replace("<join>", "JPG/PNG")  
            this.file = null
        },
        async submitFile() {
            let selectedCompanyContext = this.$store.getters.getSelectedOverAllCompany.context
            this.formData.append('file', this.file)
            this.showUploadActions = false
            this.dialogText = this.$t('lang_GENERAL_FILE_UPLOAD_DIALOG_TEXT_FILE_IS_BEING_UPLOADED')

            // Store action call to upload a file
            let response = await this.$store.dispatch('uploadA6BackgroundImage', { file : this.formData, item: this.item }) 
            
            if(response.error === -1) {
                this.dialogText = this.$t(response.txt)
                this.showCloseButton = true
                
                // Update the settings data, do fetch call again
                if(selectedCompanyContext === 1) this.$store.dispatch('fetchPublishingSettings')
                else this.$store.dispatch('fetchLabelSettings')
            } else {
                this.file = null
                this.dialogText = response.errorMsg 
            }

            this.dialogText += '<br />' + this.$t('lang_GENERAL_DIALOG_TEXT_CLOSE_DIALOG')
        },
        isA6BackgroundFileExtAccepted() {
            return (this.fileExt === 'pdf' || this.fileExt === 'jpg' || this.fileExt === 'png')
        },
        async resetVal() {
            await this.$nextTick()
            this.file = null
        },        
    },
    created() {
        this.dialogText = this.$t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') 
                        + ' ' + this.$t('lang_ACCOUNT_SETTINGS_DIALOG_BACKGROUND_FILE_A6') + '. <br />' +
                        this.$t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE').replace("<join>", "JPG/PNG")  
    }
}
</script>